module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XRlggw/tc-custom/9781035843879.jpg?1720272536010",
      "alt": "This image is the cover for the book Pretend With Me"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pretend With Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Have you ever felt adrift, living a life that doesn’t seem to belong to you, ensnared by choices you didn’t make? Catherine Carell was on the brink of surrendering to that feeling when an unexpected chance rekindled her determination, propelling her into the orbit of Jackson Hunter, a movie star whose life appears to have it all. But appearances can be deceiving. As the lines between professionalism and desire blur, and their connection deepens, a secret Catherine harbours threatens to emerge. In a world where reality and pretence intertwine, how long can she keep her secret hidden? And when the truth finally comes to light, will it have the power to shatter everything they believed in? This story navigates the complexities of love, identity, and the weight of secrets, posing the question: Is the truth enough to set them free, or is it a harbinger of ruin?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carley-Ann Osborn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Growing up near London, Carley-Ann Osborn has always had a love of books and especially loved the ones that take you on a character’s journey through their eyes. Writing was more for her own entertainment in her youth but was left on the back burner as a young adult. It wasn’t until her mid-30s that the love for reading and writing came back into her life, and she hasn’t been able to stop since.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0